import { Incident } from "../models/Incident";
import { map, uniqBy, forEach, reduce, filter } from 'lodash';
import { SEVERITY, IDLE_TIME_INCIDENT_NAME} from "../constants";

export interface IIncidentDetails {
	name?: string;
	events?: number;
	details?: string;
	severity?: SEVERITY;
}


export function buildIncidents(incidents:[Incident]|undefined) : [IIncidentDetails] {
	if (incidents) {

		//Currently we are using name since Incident doesn't seem to have type or something - Arthur
		const unique  = filter(map(uniqBy(incidents, inc => inc.name), inc => {
			return {name: inc.name, severity: inc.severity, details: inc.details}
		}), inc => (inc.severity === SEVERITY.CRITICAL || inc.severity === SEVERITY.WARNING));

		forEach(unique, un => {
			un.events = reduce( filter(incidents, inc => inc.name === un.name), (sum, inc) => sum + 1, 0 )
		})

		forEach(unique, un => {
			if (un.name !== IDLE_TIME_INCIDENT_NAME) {
				un.details = `${un?.events} events`
			}
		})
		return unique
	} 
	else return [] as any as [IIncidentDetails]
}